import React, { Suspense, lazy } from 'react';
// import {  BrowserRouter } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import Layout from './components/Layout';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router";
import Home from './pages/Home';
import { CustomBreadcrumbProvider } from './contexts/CustomBreadcrumb';
import BreadcrumbsComponent from './components/BreadcrumbsComponent';
import DashboardGrid from './pages/dashboard/Dashboard';
import { DashboardLayout } from './pages/dashboard/Layout';
import MyCourses1 from './pages/my-courses/MyCourses';
import CourseStatistic from './pages/my-courses/CourseStatistic';
import CourseActivity from './pages/my-courses/CourseActivity';
import MyContests from './pages/my-contests/MyContests';
import LearningTool from './pages/learning-tool/LearningTool';
import Twinspace from './pages/my-twinspace/MyTwinspace';
import { TwinspaceLayout } from './pages/my-twinspace/Layout';
import PMineTest from './pages/pminetest/PMineTest';
import { MyBadgeLayout } from './pages/MyBadge/Layout';
import MyBadge from './pages/MyBadge/MyBadge';
import MyContestsPage from './pages/my-contests';
import ContestDetailPage from './pages/my-contests/[contestId]';
import MissionDetailPage from './pages/my-contests/[contestId]/missions/[missionId]';
import { MyCertificateLayout } from './pages/MyCertificate/Layout';
import MyCertificate from './pages/MyCertificate/MyCertificate';
import CertFAQ from './pages/CertFAQ/CertFAQ';
import { UserOrderLayout } from './pages/MyOrder/Layout';
import MyOrder from './pages/MyOrder/MyOrders';
import MyAsset from './pages/MyAsset/MyAsset';
import UserProfile from './pages/UserProfile/Profile';
import { UserProfileLayout } from './pages/UserProfile/Layout';
import { AvatarProvider } from './contexts/AvatarContext';
import ParentConnection from './pages/UserProfile/ConnectParent/ConnectParentForm';
import ConfirmationMessageConnect from './pages/UserProfile/ConnectParent/SuccessConnect';
import ConfirmationMessageInvite from './pages/UserProfile/ConnectParent/SuccessInvite';
import EmailVerified from './pages/verify/Verify';
import { MyLeanbotsLayout } from './pages/my-leanbots/Layout';
import MyLeanbot from './pages/my-leanbots/My-Leanbot';
// const Home = lazy(() => import('./pages/Home'));
// const PackageManagement = lazy(() => import('./pages/PackageManagement'));

// const LoadingComponent = () => <div>Loading...</div>; // Custom loading component
// const SuspenseWrapper = (...props:React.LazyExoticComponent<React.FC<{}>>[]) => {
//   return <Suspense fallback={<LoadingComponent />}>
//   {props.map((Element)=>{
//     return <Element />
//   })}
// </Suspense>
// }

function PreserveQueryNavigate({ to }: { to: string }) {
  const location = useLocation();
  const query = location.search; // Lấy query string hiện tại
  return <Navigate to={`${to}${query}`} />;
}




function App() {
  return (
    <>
      <AvatarProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/"  >
              <Route path="student-workspace" Component={Layout} >
                {/* <Route index Component={Distributor}  /> */}
                {/* <Route index  Component={()=>{
                  return <Navigate to="dashboard" />
                }} /> */}
                <Route
                  index
                  element={<PreserveQueryNavigate to="dashboard" />}
                />
                <Route path="dashboard" Component={DashboardLayout}>
                  <Route index Component={DashboardGrid}></Route>
                </Route>
                <Route path="my-courses" Component={MyCourses1} />
                <Route path="course-statistics" Component={CourseStatistic} />
                <Route path="course-activities" Component={CourseActivity} />
                <Route path="my-contests">
                  <Route index Component={MyContestsPage} />
                  <Route path=":contestId">
                    <Route index Component={ContestDetailPage} />
                    <Route path=":missionId" Component={MissionDetailPage} />
                  </Route>
                </Route>
                <Route path="my-learning-tools" Component={LearningTool} />
                <Route path="my-leanbots" Component={MyLeanbotsLayout}>
                  <Route index Component={MyLeanbot}></Route>
                </Route>
                <Route path="my-twinspace" Component={TwinspaceLayout}>
                  <Route index Component={Twinspace}></Route>
                </Route>
                <Route path="pminetest">
                  <Route index Component={PMineTest}></Route>
                </Route>
                <Route path="my-badges" Component={MyBadgeLayout}>
                  <Route index Component={MyBadge}></Route>
                </Route>
                <Route path="my-certificates" Component={MyCertificateLayout}>
                  <Route index Component={MyCertificate}></Route>
                </Route>
                <Route path="opencert-faq" Component={CertFAQ}>
                </Route>
                <Route path="my-orders" Component={UserOrderLayout}>
                  <Route index Component={MyOrder}></Route>
                </Route>
                <Route path="my-assets" Component={MyAsset} />
                <Route path="my-profile" Component={UserProfileLayout}>
                  <Route index Component={UserProfile}></Route>
                  <Route path="connect-parent">
                    <Route index Component={ParentConnection}></Route>
                    <Route path="success-connect" Component={ConfirmationMessageConnect} />
                    <Route path="success-invite" Component={ConfirmationMessageInvite} />
                  </Route>
                </Route>
                <Route path="verify-email" Component={EmailVerified} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AvatarProvider>
    </>
  );
}

export default App;

